import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Layout, Segment, Radio, Switch, message } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import {
  BenchmarkSegment,
  defaultFigureData,
  defaultConfigValue,
  DefaultRevenueValue,
  BenchmarkSecondSegment,
} from './_config/constant';
import {
  getMetricsDataByCategory,
  transferMetricToConfig,
} from './_config/table';
import {
  RevenueValue,
  GameSegmentType,
  FigureData,
  RevenueSegmentType,
  GameConfigType,
  VidoeBenchmarkRankType,
  BenchmarkGameItem,
  IMetricSelectMultipleCompValue,
} from './types';
import {
  getVidoeBenchmarkFigured,
  getVidoeBenchmarkGameList,
  getVidoeBenchmarkAllGameList,
  addVidoeBenchmarkCustomizeGame,
  getCollectionGroupByEntityTypes,
  getTopChartsVidoeBenchmarkRankList,
} from '../../services/pcConsoleBenchmark';
import type { Tab } from 'tea-component';
import TimeStandardAction from './components/TimeStandardAction';
import GamesTransferSelector from './components/GamesTransferSelector';
import { Game } from './components/GamesTransferSelector/type';
import Summary from './components/Summary';
import Retention from './components/Retention';
import RevenueUnitsTrends from './components/RevenueUnitsTrends';
import RevenuePercentage from './components/RevenuePercentage';
import TableContent from './components/TableContent';
import RevenueSelector from './components/RevenueSelector';
import AboutTheData from './components/AboutTheData';
import { useIntl, useLocation, history, getLocale } from 'umi';
import FollowGame from './components/FollowGame'

import {
  buriedPointPage,
  buriedBtnPoint,
} from '@/pages/home/utils/buriedPoint';
import {
  dbiBtnLogMes,
  dbiPageLogMes,
} from '@/pages/intelligence/utils/buriedPointCfg';

import { reduce, debounce, uniq, result } from 'lodash-es';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import './index.scss';

const { Body, Content } = Layout;

const PCConsoleBenchMark = () => {

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const tabs: Tab[] = [
    { id: 'Figure', label: formatMessage({ id: 'dbi_benchmark_figure'}) },
    { id: 'Stats', label: formatMessage({ id: 'dbi_benchmark_stats'})},
  ];

  const benchmarkRef = useRef<HTMLDivElement>(null);
  const statsRef = useRef<HTMLDivElement>(null);
  /** tab activeId */
  const [activeId, setActiveId] = useState('Figure');
  /** Stats segment activeSegment1 */
  const [activeSegment1, setActiveSegment1] =
    useState<GameSegmentType>('shooter');
  const [lastSegment, setLastSegment] = useState<GameSegmentType>('shooter');
  /** Stats segment activeSegment2 */
  const [activeSegment2, setActiveSegment2] =
    useState<RevenueSegmentType>('us_digital_revenue');
  /**US Digital Revenue 筛选器值 */
  const [revenueValue, setRevenueValue] =
    useState<RevenueValue>(DefaultRevenueValue);
  const [activeSegment3, setActiveSegment3] = useState('Earliest Date');
  /** 穿梭框visible */
  const [visible, setVisible] = useState(false);
  const [isTextOpen, setIsTextOpen] = useState(false);
  const [configLoading, setConfigLoading] = useState(false);
  const [loadingAllGame, setLoadingAllGame] = useState(false);
  /** 控制穿梭空 shortcut按钮异步请求问题 */
  const [settingLoading, SetSettingLoading] = useState(false);
  /** table loading */
  const [loading, setLoading] = useState(false);
  /** totalNum */
  const [totalNum, setTotalNum] = useState(0);
  /** table数据 */
  /** figure loading */
  const [figureLoading, setFigureLoading] = useState(true);
  const [dataSource, setDataSource] = useState<VidoeBenchmarkRankType[]>([]);
  /*** 自定义游戏值 */
  const [customValue, setCustomValue] = useState<any[]>([]);

  const [isPoeGame, setIsPoeGame] = useState(false);

  const [gameConfig, setGameConfig] =
    useState<GameConfigType<BenchmarkGameItem>>(defaultConfigValue);

  /** 游戏筛选器值*/
  const [gameValue, setGameValue] =
    useState<GameConfigType<string>>(defaultConfigValue);

  /** Time Basis Radio选择框 */
  const [timeBasis, setTimeBasis] = useState('0');
  /*** Align across PC & Console version开关 */
  const [isAlignAcross, setIsAlignAcross] = useState(false);
  /** 游戏筛选器列表 */
  const [gameAllList, setAllGameList] = useState<BenchmarkGameItem[]>([]);

  const [groupList, setGroupList] =  useState<any[]>([]);

  const [apiParams, setApiParams] = useState<any>({
    page_size: 20,
    order_source: 'us_digital_revenue',
  });

  const [statsBottom, setStatsBottom] = useState<any>(null)

  const { query } = useLocation();

  const [figureData, setFigureData] = useState<FigureData>(defaultFigureData);

  const INITIAL_CATEGORY = BenchmarkSecondSegment?.[0]?.value || '';
  const { values: INITIAL_METRICS } =
    getMetricsDataByCategory(INITIAL_CATEGORY);

  const [checkedMetricsData, setcheckedMetricsData] =
    useState<IMetricSelectMultipleCompValue>({
      category: INITIAL_CATEGORY,
      metrics: INITIAL_METRICS,
    });

  const [checkedMetricsConfigs, setcheckedMetricsConfigs] = useState(
    transferMetricToConfig(checkedMetricsData),
  );

  const statusSegmentList = useMemo(()=> {
    return BenchmarkSecondSegment?.map(item=> ({
      ...item,
      text: formatMessage({id: item?.text || ''})
    }))
  }, [BenchmarkSecondSegment, locale])  

  /** tab 切换 */
  const handleTabChange = (tab) => {
    setActiveId(tab.id);
    if (tab.id === 'Figure') {
      if (benchmarkRef.current) {
        // 平滑的滚动到顶部
        benchmarkRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
      }
      const pageMsg = dbiPageLogMes?.pcConsoleBenchmarkFigure;
      if (pageMsg) {
        buriedPointPage(pageMsg);
      }
    }

    if (tab.id === 'Stats') {
      if (benchmarkRef.current && statsRef.current) {
        // 平滑的滚动stats所在位置
        benchmarkRef.current?.scrollTo({
          top: statsRef.current.offsetTop + 80,
          behavior: 'smooth',
        });
      }
      const pageMsg = dbiPageLogMes?.pcConsoleBenchmarkStatus;
      if (pageMsg) {
        buriedPointPage(pageMsg);
      }
    }
  };

  /** benchmark页面滚动事件 */
  const handleBenchmarkScroll = debounce((e) => {
    if (statsRef.current) {
      const height =
        document.body.clientHeight || document.documentElement.clientHeight;
      // 目标元素距离可视区域的宽度
      const top = statsRef.current?.getBoundingClientRect()?.top;
      // 如果stats出现在屏幕中间一下属于figure部分
      const target = (height - 50 - 40) / 2;
      if (top < target) {
        setActiveId('Stats');
      } else {
        setActiveId('Figure');
      }
      if(!loading){
        const bottom = height - top;
        setStatsBottom(bottom < 300? 300: bottom);
      }
    }
  }, 200);

  /** 游戏分类segment change事件 */
  const handleSegmentChange = async (value: GameSegmentType) => {
    setLastSegment(activeSegment1);
    setActiveSegment1(value);
    history.replace(`/intelligence/benchmark/pcConsoleBenchmark?tab=${value === 'customize' && isPoeGame? 'poe':  value}`);

    if (value === 'customize' && !customValue.length) {
      // 当Customized为空态时，隐藏Customize a game set，且点击Customized后弹出弹窗选择游戏
      setVisible(true);
      await getBenchmarkGameList(
        ['shooter', 'soc', 'rpg', 'mmo', 'casual', 'customize'],
        false,
      );
      return;
    }

    getVidoeBenchmarkFiguredData({
      game_code: [],
      genre_type: value,
    });

    getBenchmarkTableList({
      game_code: [],
      genre_type: value,
    });
  };

  const handleSetting = async () => {
    setIsTextOpen(true);
    setVisible(!visible);
    await getBenchmarkGameList(
      ['shooter', 'soc', 'rpg', 'mmo', 'casual', 'customize'],
      false,
    );
    const btnMsg = dbiBtnLogMes?.pcConsoleBenchmarkSetting;
    buriedBtnPoint(btnMsg);
  };

  const getFigureTab = (timeBasis: string, alignAcross: boolean) => {
    if (alignAcross) {
      return timeBasis === '0'
        ? 'PC&Console Aligned by Earliest Date'
        : 'PC&Console Aligned by Release Date';
    } else {
      return timeBasis === '0' ? 'Earliest Date' : 'Release Date';
    }
  };

  /*** TimeBasis Change事件 */
  const handleTimeBasisChange = (value: string) => {
    if (value === timeBasis) return;
    getVidoeBenchmarkFiguredData({
      figure_tab: getFigureTab(value, isAlignAcross),
    });
    const pcFrontBlock = document.getElementById('pcFrontBlock');
    const consoleFrontBlock = document.getElementById('consoleFrontBlock');
    // 移除动画效果;
    pcFrontBlock?.removeAttribute('class');
    consoleFrontBlock?.removeAttribute('class');
    setTimeBasis(value);
  };

  /** Align across PC & Console version开关change事件 */
  const handleAlignAcrossChange = (value: boolean) => {
    getVidoeBenchmarkFiguredData({
      figure_tab: getFigureTab(timeBasis, value),
    });
    const pcFrontBlock = document.getElementById('pcFrontBlock');
    const consoleFrontBlock = document.getElementById('consoleFrontBlock');
    // 移除动画效果
    pcFrontBlock?.removeAttribute('class');
    consoleFrontBlock?.removeAttribute('class');

    setIsAlignAcross(value);
  };

  const handleTransferCancel = () => {
    if (!isTextOpen) {
      setActiveSegment1(lastSegment);
    }
    setIsTextOpen(false);
    const btnMsg = dbiBtnLogMes?.pcConsoleBenchmarkCustomizeConfirm;
    btnMsg && buriedBtnPoint(btnMsg);
  };

  const handleTransferConfirm = async (value: Game[]) => {
    // 若已经在Customized选过游戏了，再次打开Customize a game set弹窗
    // 并删除全部游戏，则默认回到SOC页并提示

    await addVidoeBenchmarkCustomizeGame({
      game_ids: value?.map((item) => item.id) || [],
      genre_type: 'customize',
      is_url: false
    });
    const btnMsg = dbiBtnLogMes?.pcConsoleBenchmarkCustomizeConfirm;
    btnMsg && buriedBtnPoint(btnMsg);

    if (!value.length) {
      message.success({
        content: 'Custom games have been cleared.',
      });
      setActiveSegment1('shooter');
      getVidoeBenchmarkFiguredData({ genre_type: 'shooter' });
      getBenchmarkTableList({ genre_type: 'shooter' });
    } else {
      setActiveSegment1('customize');
      getBenchmarkGameList(['shooter', 'soc', 'rpg', 'mmo', 'casual', 'customize']);
      getVidoeBenchmarkFiguredData({ genre_type: 'customize' });
      getBenchmarkTableList({ genre_type: 'customize' });
    }

    setVisible(false);
    setIsTextOpen(false);
  };

  /** Stats筛选器处理 */
  const handleRevenueChange = (
    value: RevenueValue,
    type: 'reset' | 'confirm',
  ) => {
    setRevenueValue(value);
    getBenchmarkTableList({ revenue: value });
  };

  /** stats下面segment change事件 */
  const handleSegment2Change = (value: RevenueSegmentType) => {
    if(statsRef.current){
     
    }
    
    if (value === 'us_digital_revenue') {
      getBenchmarkTableList({
        sources: value,
        revenue: revenueValue,
      });
    } else {
      const list = {
        category: value,
        metrics: getMetricsDataByCategory(value)?.values || [],
      };
      const config = transferMetricToConfig(list);
      setcheckedMetricsConfigs(config);
      setcheckedMetricsData(list);
      getBenchmarkTableList({
        sources: value,
      });
    }
    setActiveSegment2(value);
  };

  /*** 获取游戏分类列表 */
  const getBenchmarkGameList = async (
    genre_type?: GameSegmentType[] | null,
    needLeading = true,
    openTransfer = false
  ) => {
    if (needLeading) {
      setConfigLoading(true);
    }
    SetSettingLoading(true);

    const data = await getVidoeBenchmarkGameList({
      entity_type: ['pc', 'console'],
      genre_type: genre_type
        ? genre_type
        : ['shooter', 'soc', 'rpg', 'mmo', 'casual', 'customize'],
    });
    const list = data || [];
    // 第一排 segment对应的游戏筛选器列表
    const segmentGameConfig = reduce(
      list,
      (result, item) => {
        result[item.genre_type] = item?.list || [];
        return result;
      },
      {} as GameConfigType<BenchmarkGameItem>,
    );

    // 游戏筛选框默认值
    const gameValueConfig = reduce(
      list,
      (result, item) => {
        result[item.genre_type] = item?.list?.map((config) => config?.id) || [];
        return result;
      },
      {} as GameConfigType<string>,
    );

    setGameConfig(segmentGameConfig);
    setGameValue(gameValueConfig);

    if(openTransfer && !gameValueConfig?.customize.length){
      setVisible(true);
    }
    if (needLeading) {
      setConfigLoading(false);
    }

    SetSettingLoading(false);
  };

  /*** 获取穿梭框左侧所有游戏列表 */
  const getBenchmarkAllGameList = async () => {
    setLoadingAllGame(true);
    const data = await getVidoeBenchmarkAllGameList({
      entity_type: ['pc', 'console'],
      genre_type: [],
    });

    const list = data?.find((item) => item?.genre_type === 'all')?.list || [];
    setAllGameList(list);
    setLoadingAllGame(false);
  };

  /** 获取figure页面数据 */
  const getVidoeBenchmarkFiguredData = async (params: any) => {
    setFigureLoading(true);
    setFigureData(defaultFigureData);
    const res = await getVidoeBenchmarkFigured({
      game_code: params?.game_code || apiParams?.game_code || [],
      figure_tab: params?.figure_tab || activeSegment3,
      genre_type: params?.genre_type || activeSegment1,
      ...params,
    });

    const {
      pc_players_by_country,
      gas,
      trends,
      summary,
      us_revenue,
      retention_curve,
      arpu_retention,
    } = res || {};

    const gasLinexAxis =
      gas?.console?.map((item, index) => `${index + 1}`) || [];
    const gasLineData = reduce(
      gas,
      (result, value, key) => {
        if (key === 'pc') {
          result.push({
            type: 'line',
            showSymbol: false,
            name: 'PC',
            symbolSize: 10,
            symbol: 'circle',
            emphasis: {
              itemStyle: {
                borderWidth: 1,
                borderColor: '#fff'
              }
            },
            data: value?.map((item) => (item.value * 100).toFixed(2)),
          });
        }
        if (key === 'console') {
          result.push({
            type: 'line',
            showSymbol: false,
            name: 'Console',
            symbolSize: 10,
            symbol: 'circle',
            emphasis: {
              itemStyle: {
                borderWidth: 1,
                borderColor: '#fff'
              }
            },
            data: value?.map((item) => (item.value * 100).toFixed(2)),
          });
        }
        return result;
      },
      [] as any,
    );

    const countryPieData =
      pc_players_by_country?.map((item) => ({
        type: 'pie',
        name: item?.type,
        name_zh: item?.type_cn,
        value: item?.value,
        dod: item?.dod
      })) || [];

    setFigureLoading(false);

    setFigureData({
      countryPieData, // 饼图数据
      gasLinexAxis,
      gasLineData: gasLineData.reverse(),
      summary, // summary总结数据
      trends,
      usRevenue: us_revenue || [], // Top 10 Games of US Digital Revenue图数据
      retentionCurve: retention_curve || [], // Distribution 图数据
      arpuRetention: arpu_retention || [], // Retention Rank Curve折线图数据
    });
  };

  /*** 获取Table列表 */
  const getBenchmarkTableList = async (params?: {
    sources?: string;
    page?: number;
    revenue?: RevenueValue;
    pageSize?: number;
    search_game_code?: string[];
    game_code?: string[];
    genre_type?: GameSegmentType;
    order?: 'desc' | 'asc';
    order_metric?: string;
    order_source?: string;
  }) => {
    setLoading(true);
    const segment2 = params?.sources || activeSegment2;
    const revenue = params?.revenue
      ? params?.revenue
      : segment2 === 'us_digital_revenue'
      ? revenueValue
      : {};
    const apiParamsSource = {
      game_code: [],
      order_source: params?.order_source || apiParams?.order_source,
      order: params?.order || 'desc',
      order_metric:
        params?.order_metric ||
        apiParams?.order_metric ||
        'pc+console_est_af_rev_all',
      search_name: '',
      page: params?.page || 1,
      page_size: params?.pageSize || apiParams?.page_size || 20,
      search_game_code: params?.search_game_code || [],
      sources: [segment2],
      source_tab: segment2,
      genre_type: params?.genre_type || activeSegment1,
      ...revenue,
    };

    const res = await getTopChartsVidoeBenchmarkRankList(apiParamsSource);

    const { total, rank_au_list } = res?.data || {};
    const orderMetricReq = res?.req?.order_metric || '';
    const reqOrder = res?.req?.order || '';

    setApiParams({
      ...apiParamsSource,
      order_metric: orderMetricReq,
      order: reqOrder,
    });
    const tableList = rank_au_list?.map((item) => {
      const newMetricMap = {} as any;
      item?.metric_list?.forEach((meticItem) => {
        newMetricMap[meticItem.title] = meticItem;
      });
      return {
        ...item,
        metric_map: newMetricMap,
      };
    });
    setDataSource(tableList || []);
    setLoading(false);
    setTotalNum(total);
  };

 
  const initData = (genreType?: GameSegmentType, openTransfer?: boolean)=> {
    const params = genreType ? { genre_type: genreType} : {}
    getBenchmarkGameList(null, true, openTransfer);
    getBenchmarkAllGameList();
    getVidoeBenchmarkFiguredData(params);
    getBenchmarkTableList(params);
    getCollectionGroupList()
  }


  const getCollectionGroupList = async()=> {
    const res:any = await getCollectionGroupByEntityTypes(['pc', 'console']);
    const list = res?.group_lists || []
    
    if(Array.isArray(list)){
      const groupList = list.reduce((result, item)=> {
       const group = item?.group_lists || [];
       return result.concat(Array.isArray(group) ? group: []);
      }, [])
      setGroupList(groupList)
    }else{
      setGroupList([]);
    }
  }
   

  const setUrlCustomizeGame = async(ids: string[])=> {
    await addVidoeBenchmarkCustomizeGame({
      genre_type: 'customize',
      game_ids: ids,
      is_url: true
    })
    initData('customize', true);
  }

  /** 页面初始化 */
  useEffect(() => {
    const { tab, gameIds } = query;
    const genreType = Array.isArray(tab) ? tab[tab?.length -1]: tab;
    const genreTypeList = BenchmarkSegment?.map(item=> item.value);
    // 判断是否携带游戏品类tab参数切是否是规定的游戏品类
    if(genreType && [...genreTypeList, 'poe'].includes(genreType)){
      if(genreType === 'customize' || genreType === 'poe'){
         // 如果携带参数游戏品类是自定义且携带游戏id ,先做自定义游戏保存处理

        if(genreType === 'poe'){
          setIsPoeGame(true);
        }
        if(gameIds){
          // 处理游戏参数
          let idList:any[] = []
          if(Array.isArray(gameIds)){
            idList = gameIds.filter(item => item)
          }else{
            idList = gameIds?.split(',')?.filter(item => item)
          }
          
          //调用自定义保存接口
          setUrlCustomizeGame(uniq(idList));
          setActiveSegment1('customize');
          return;
        }

        setActiveSegment1('customize')
        // 如果自定义游戏为空打开穿梭框
        initData('customize', true);

      }else{
        initData(genreType);
        setActiveSegment1(genreType);
        setIsPoeGame(false);
      }
      
    }else{
      initData();
    }

    // 页面初始打点
    const pageMsg = dbiPageLogMes?.pcConsoleBenchmark;
    if (pageMsg) {
      buriedPointPage(pageMsg);
    }
  }, []);

  useEffect(() => {
    const defaultCustomValue =
      gameAllList
        ?.filter((item) => gameValue?.customize?.includes(item.id))
        ?.map((item) => ({
          id: item.id,
          entityType: item.entity_type,
          entityName: item.entity_name,
          releaseTime: item.release_time,
          cover: item.cover,
          publisher: item.company,
          matchScore: 1,
        })) || [];

    setCustomValue(defaultCustomValue);
  }, [gameValue, gameAllList]);

  const gameSegmentList = useMemo(()=> {

    return BenchmarkSegment?.map(item=> ({
      ...item,
      text: formatMessage({id: item.value === 'customize' && isPoeGame? 'dbi_benchmark_poe_like': item?.text }),
      name: item.value === 'customize' && isPoeGame? 'POE-like' : item?.name
    }))
  }, [locale, isPoeGame])

  return (
    <Content className="dbi-benchmark" ref={benchmarkRef} onScroll={handleBenchmarkScroll}>
      <div className="dbi-benchmark-infotips">
        <AboutTheData />
      </div>
      <Content.Header
        className="dbi-header contentHead-normal dbi-benchmark-header"
        title={formatMessage({ id: 'dbi_benchmark_pc_console_benchmark' })}
      >
        <div className="dbi-benchmark-header-des">
          {formatMessage({ id: 'dbi_benchmark_introduce' }) }
        </div>
        <div className="header-tab">
          <Tabs
            ceiling
            animated={false}
            onActive={(tab) => handleTabChange(tab)}
            activeId={activeId}
            tabs={tabs}
          />
        </div>
      </Content.Header>
      <Content.Body full>
        <MarqueeBanner />
        <div className="dbi-benchmark-gametype">
          <div className="dbi-benchmark-gametype-l">
            <div className="dbi-benchmark-segment-setting">
              <Segment
                className="dbi-benchmark-segment segment-light"
                options={gameSegmentList}
                value={activeSegment1}
                disabled={configLoading}
                onChange={(value) =>
                  handleSegmentChange(value as GameSegmentType)
                }
              />
              <span
                className="dbi-benchmark-gametype-customize"
                style={
                  activeSegment1 === 'customize' && customValue.length > 0
                    ? { opacity: 1 }
                    : { opacity: 0 }
                }
                onClick={handleSetting}
              >
                {formatMessage({id: 'dbi_benchmark_setting'})}
              </span>
              {visible && (
                <GamesTransferSelector
                  title={formatMessage({id: 'dbi_benchmark_customize_set' })}
                  visible={visible}
                  gameConfig={{ ...gameConfig, all: gameAllList }}
                  value={customValue}
                  entityType="mobile"
                  settingLoading={settingLoading}
                  loadingAllGame={loadingAllGame}
                  setVisible={setVisible}
                  onCancel={handleTransferCancel}
                  onConfirm={(value) => handleTransferConfirm(value)}
                />
              )}
            </div>
            <div className="dbi-benchmark-gametype-row">
              <span className="dbi-benchmark-gametype-label">{formatMessage({ id: 'dbi_benchmark_time_basis'})}</span>
              <Radio.Group
                value={timeBasis}
                disabled={figureLoading}
                onChange={(value) => handleTimeBasisChange(value)}
              >
                <Radio name="0">{formatMessage({id: 'dbi_benchmark_earliest_data_date'})}</Radio>
                <Radio name="1">{formatMessage({id: 'dbi_benchmark_release_date'})}</Radio>
              </Radio.Group>
            </div>
            <div className="dbi-benchmark-gametype-row">
              <span className="dbi-benchmark-gametype-label">
                {formatMessage({id: 'dbi_benchmark_align_across'})}
              </span>
              <Switch
                value={isAlignAcross}
                disabled={figureLoading}
                onChange={(value) => {
                  handleAlignAcrossChange(value);
                }}
              />
            </div>
            <div className="dbi-benchmark-follow-genre">
              <FollowGame
                loading={configLoading}
                entity_type='combine'
                gameList={gameConfig[activeSegment1]}
                genreList={ gameSegmentList}
                genre={activeSegment1}
                getCollectionGroupList={getCollectionGroupList}
                groupList={groupList} />
              {/* <span >
                {formatMessage({id: 'dbi_benchmark_follow_game_genre'})}
              </span> */}
            </div>
          </div>
          <div className="dbi-benchmark-gametype-r">
            <TimeStandardAction
              timeStandard={getFigureTab(timeBasis, isAlignAcross)}
              isAlignAcross={isAlignAcross}
            />
          </div>
        
        </div>
        <div>
          <Summary
            summary={figureData?.summary || {}}
            loading={figureLoading}
            segmentMain={activeSegment1}
            segmentSub={activeSegment2}
            isPoeGame={isPoeGame}
          />
          <RevenueUnitsTrends
            loading={figureLoading}
            trendsData={figureData?.trends}
          />
          <RevenuePercentage
            loading={figureLoading}
            lineData={figureData?.gasLineData || []}
            pieData={figureData?.countryPieData || []}
            linexAxis={figureData?.gasLinexAxis}
          />
          <Retention
            gameSegment={activeSegment1}
            loading={figureLoading}
            usRevenue={figureData?.usRevenue}
            arpuRetention={figureData?.arpuRetention || []}
            retentionCurve={figureData?.retentionCurve || []}
          />
        </div>
        <div
          ref={statsRef}
          id="pcStats"
          className="dbi-benchmark-stats"
          style={{ marginTop: 20 }}
        >
          <div className="dbi-benchmark-stats-title">
            {formatMessage({ id: 'dbi_benchmark_stats'})} 
          </div>
          <Segment
            className="dbi-benchmark-stats-segment segment-light"
            options={statusSegmentList}
            value={activeSegment2}
            disabled={loading}
            onChange={(value) =>
              handleSegment2Change(value as RevenueSegmentType)
            }
          />
          {activeSegment2 === 'us_digital_revenue' && (
            <RevenueSelector
              value={revenueValue}
              onChange={handleRevenueChange}
            />
          )}
        </div>
        <TableContent
          loading={loading}
          statsBottom={statsBottom}
          apiParams={apiParams}
          page={apiParams?.page || 1}
          totalNum={totalNum}
          tableList={dataSource}
          revenueValue={revenueValue}
          tHeaderList={checkedMetricsConfigs}
          segment={activeSegment2}
          figureSegment={activeSegment1}
          orderMetric={apiParams?.order_metric}
          checkedMetricsData={checkedMetricsData}
          handleFetchTable={getBenchmarkTableList}
        />
      </Content.Body>
    </Content>
  );
};

export default PCConsoleBenchMark;
